module.exports = __webpack_public_path__ + "img/madrid_chamberi.508b0803.jpg";